module.exports = __webpack_public_path__ + "img/slide5.6750785f.jpg";